import React, { useState, useRef, useEffect } from "react";
import { VuesaxBulkKey1 } from "./ui/VuesaxBulkKey1";
import { VuesaxBulkSms1 } from "./ui/VuesaxBulkSms1";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-hot-toast";
import { useGoogleLogin } from "@react-oauth/google";
import { FiEye, FiEyeOff } from "react-icons/fi";
// --- Your OtpInput and OtpVerificationBox components here ---
import { useNavigate, Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKAPI_URL;

// OtpInput as in your code
function OtpInput({ value, onChange, disabled }) {
  const DIGITS = 6;
  const inputRefs = useRef([]);

  if (inputRefs.current.length !== DIGITS) {
    inputRefs.current = Array.from({ length: DIGITS }, () => React.createRef());
  }

  const handlePaste = (e) => {
    const text = e.clipboardData
      .getData("Text")
      .trim()
      .replace(/[^0-9]/g, "")
      .slice(0, DIGITS);
    if (text.length === DIGITS) {
      onChange(text);
      inputRefs.current[DIGITS - 1].current?.focus();
      e.preventDefault();
    }
  };

  const handleChange = (e, idx) => {
    let val = e.target.value.replace(/[^0-9]/g, "");
    if (val.length > 1) val = val.slice(-1);
    const newValue = value.split("");
    newValue[idx] = val;
    onChange(newValue.join("").padEnd(DIGITS, ""));
    if (val && idx < DIGITS - 1) inputRefs.current[idx + 1].current?.focus();
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !value[idx] && idx > 0) {
      inputRefs.current[idx - 1].current?.focus();
    }
  };

  return (
    <div
      className="
        inline-flex
        justify-center
        gap-2
        sm:gap-3
        w-full
        flex-wrap
        sm:flex-nowrap
      "
    >
      {Array.from({ length: DIGITS }).map((_, i) => (
        <div
          key={i}
          className="
            inline-flex items-center p-2.5 relative
            rounded-lg border-[none]
            before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-lg 
            before:[background:linear-gradient(356deg,rgba(45,40,66,1)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,1)_97%)] 
            before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] 
            before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none
          "
        >
          <input
            className="w-10 h-12 sm:w-12 sm:h-14 text-center text-xl sm:text-2xl bg-transparent outline-none text-[#bebebe]"
            type="text"
            maxLength={1}
            ref={inputRefs.current[i]}
            value={value[i] || ""}
            onChange={(e) => handleChange(e, i)}
            onPaste={handlePaste}
            onKeyDown={(e) => handleKeyDown(e, i)}
            inputMode="numeric"
            pattern="[0-9]*"
            autoFocus={i === 0}
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  );
}

// OtpVerificationBox as in your previous code
function OtpVerificationBox({
  email,
  otp,
  setOtp,
  onVerify,
  minutes,
  seconds,
  loading,
  resendDisabled,
  onResend,
}) {
  return (
    <div className="relative w-full max-w-xl mx-auto mt-10 px-4">
      <div
        className="flex flex-col w-full items-center justify-end gap-6 sm:gap-8 p-4 sm:p-10 md:p-16 rounded-3xl border-t-[6px] border-b-[6px] border-none relative
        before:content-[''] before:absolute before:inset-0 before:p-1.5 before:rounded-3xl
    
        before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
        before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none bg-[#2a223a]"
      >
        <div className="inline-flex flex-col items-center gap-6 sm:gap-8 relative z-10 w-full">
          {/* Logo, Title, Instruction */}
          {/* ... As your previous code ... */}
          <div className="relative w-[161.09px] h-16 mb-4">
            <img
              className="absolute w-[50px] h-16 top-0 left-0"
              alt="Logo"
              src="https://c.animaapp.com/md7w1vbr66bQVi/img/freepik--the-style-is-candid-image-photography-with-natural--633.png"
            />
            <div className="absolute w-[108px] h-[51px] top-[13px] left-[57px]">
              <div className="relative w-[104px] h-[51px]">
                <div
                  className="absolute top-0 left-0 bg-[linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)]
                  [-webkit-background-clip:text] bg-clip-text [-webkit-text-fill-color:transparent]
                  font-normal text-transparent text-[25.4px] leading-[25.4px] whitespace-nowrap"
                >
                  BABY
                </div>
                <div
                  className="absolute top-[25px] left-0 bg-[linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)]
                  [-webkit-background-clip:text] bg-clip-text [-webkit-text-fill-color:transparent]
                  font-normal text-transparent text-[25.4px] leading-[25.4px] whitespace-nowrap"
                >
                  UNICORN
                </div>
              </div>
            </div>
          </div>
          <div className="inline-flex flex-col items-center gap-2 sm:gap-3 px-2 text-center">
            <div className="font-semibold text-white text-2xl sm:text-[32px]">
              Verification
            </div>
            <p className="font-normal text-[#bebebe] text-base sm:text-[22px]">
              Enter the code we sent to your email
            </p>
            <p className="font-bold text-[#bebebe] text-sm sm:text-[18px] break-all">
              <span className="text-[#6cc9ff]">{email}</span>
            </p>
          </div>

          {/* OTP Input */}
          <OtpInput value={otp} onChange={setOtp} disabled={loading} />

          {/* Timer and Resend */}
          <div className="inline-flex flex-col items-center justify-center gap-3 sm:gap-4">
            <p className="text-neutral-100 text-sm sm:text-xl text-center">
              Your code will expire in
            </p>
            <div
              className="flex w-full max-w-[218px] h-[104px] items-center justify-between p-4 sm:p-6 bg-[#3a335066]
              rounded-xl border-r border-l border-dashed border-[#aa81ff] backdrop-blur-[10px] relative"
            >
              <div className="flex flex-col w-[54px] items-center">
                <div className="font-bold text-white text-[32px] sm:text-[42px] text-center">
                  {minutes}
                </div>
                <div className="font-normal text-neutral-100 text-xs sm:text-lg text-center">
                  Minutes
                </div>
              </div>
              <div className="font-bold text-white text-[32px] sm:text-5xl text-center">
                :
              </div>
              <div className="flex flex-col w-[54px] items-center">
                <div className="font-bold text-white text-[32px] sm:text-[42px] text-center">
                  {seconds.toString().padStart(2, "0")}
                </div>
                <div className="font-normal text-neutral-100 text-xs sm:text-lg text-center">
                  Second
                </div>
              </div>
            </div>
            <button
              className="text-xs sm:text-sm text-[#aa81ff] hover:underline disabled:opacity-50 mt-1 sm:mt-2"
              onClick={onResend}
              disabled={resendDisabled || loading}
              type="button"
            >
              {resendDisabled
                ? `Resend OTP in ${minutes}:${seconds
                    .toString()
                    .padStart(2, "")}`
                : "Resend OTP"}
            </button>
          </div>

          {/* Verify Button */}
          <button
            onClick={onVerify}
            className="flex h-[50px] sm:h-[60px] items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 w-full
              rounded-[50px] border border-white shadow-[0px_4px_16px_#ff49b8]
              bg-[linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)]
              font-semibold text-white text-base sm:text-lg disabled:opacity-50"
            disabled={loading || otp.length !== 6}
          >
            {loading ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
      {/* Background blurs as your code, ... */}
      <div className="pointer-events-none hidden sm:block">
        <div className="w-[276px] h-[276px] top-0 right-0 sm:left-[611px] bg-[#ff75b6] rounded-full absolute blur-[400px] -z-10" />
        <div className="w-[291px] h-[291px] bottom-0 left-0 bg-[#ff81bc] rounded-full absolute blur-[400px] -z-10" />
      </div>
    </div>
  );
}

// ---- MAIN SIGNUP PAGE WITH OTP INTEGRATED ----

function SignUpPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    country_name: "",
    password: "",
    confirmPassword: "",
    referral_code: "",
  });

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  // OTP timer management
  const OTP_EXPIRE_TIME = 120; // seconds
  const [timer, setTimer] = useState(0);
  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  // Keep email in variable for OtpVerificationBox
  const email = formData.email;

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendOTP = async () => {
    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    setLoading(true);
    try {
     const res = await fetch(`${API_URL}/send_otp_signup.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email }),
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        toast.success("OTP sent to your email");
        setOtpSent(true);
        setOtp(""); // clear old OTP
        setTimer(OTP_EXPIRE_TIME);
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (otp.length !== 6) {
      toast.error("Enter all 6 digits");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/verify_signup_otp.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email, otp }),
        }
      );
      const data = await res.json();
      if (data.status === "success") {
        toast.success("OTP verified!");
        setOtpVerified(true);
        handleFinalRegistration();
      } else {
        toast.error(data.message || "OTP verification failed");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const navigate = useNavigate();

  const handleFinalRegistration = async () => {
    const {
      full_name,
      email,
      password,
      confirmPassword,
      phone,
      country_name,
      referral_code,
    } = formData;

    if (!full_name || !email || !password || !confirmPassword || !phone) {
      toast.error("Please fill all required fields.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/register.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const result = await res.json();
      if (result.status === "success") {
        toast.success("Registration successful!");
        setFormData({
          full_name: "",
          email: "",
          phone: "",
          country_name: "",
          password: "",
          confirmPassword: "",
          referral_code: "",
        });
        setOtp("");
        setOtpSent(false);
        setOtpVerified(false);
        setTimer(0);
        // redirect etc...
        setTimeout(() => {
          navigate("/profile");
        }, 1500);
      } else {
        toast.error(result.message || "Registration failed");
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  // Google Login handler (optional, as from your old code)
  const googleSignUp = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
          }
        );
        const user = await res.json();

        const signupRes = await fetch(`${API_URL}/register_google.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              full_name: user.name,
              email: user.email,
              google_id: user.sub,
              profile_pic: user.picture,
            }),
          }
        );

        const result = await signupRes.json();

        if (result.status === "success") {
          toast.success("Google Sign Up successful!");
          // Save user info & redirect...
        } else {
          toast.error(result.message || "Google sign-up failed.");
        }
      } catch (error) {
        toast.error("Google sign-up failed.");
      }
    },
    onError: () => toast.error("Google sign-up failed"),
  });

  // Timer calculation
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  // --- MAIN RENDER ---
  return (
    <div className="bg-[#1e1a2e] flex justify-center w-full min-h-screen">
      <div className="bg-[#1e1a2e] w-full md:w-[1920px] min-h-screen flex flex-col md:flex-row">
        {/* Left side... */}
        <div className="hidden md:block relative w-full md:w-[960px] h-[1120px] bg-[url('https://c.animaapp.com/md5wqfhkeEm8By/img/2151800408.png')] bg-cover bg-center">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1e1a2e]" />
          <div className="absolute bottom-36 left-10 z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-5">
              Welcome back our
            </h2>
            <h1
              className="text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent mb-22"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, rgba(255,110,179,1) 0%, rgba(170,129,255,1) 47%, rgba(107,201,255,1) 100%)",
              }}
            >
              Baby Unicorn AI
            </h1>
          </div>
        </div>
        {/* Right side */}
        <div className="w-full md:w-[887px] flex items-center justify-center px-4 py-10 ">
          <div className="flex flex-col w-full max-w-[654px] items-center gap-8  p-6 md:p-6 bg-[#2a223a] w-full max-w-lg p-10 rounded-3xl bg-[#2a223a] relative overflow-hidden before:content-[''] before:absolute before:inset-0 before:p-1.5 before:rounded-3xl before:[background:linear-gradient(90deg,rgba(45,40,66,1)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,1)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
            {!otpSent ? (
              <form
                className="flex flex-col items-start gap-6 w-full"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSendOTP();
                }}
              >
                    <div className="flex flex-col items-center gap-6 w-full">
      <div className="flex items-center gap-3">
        <img
          src="https://c.animaapp.com/md5wqfhkeEm8By/img/freepik--the-style-is-candid-image-photography-with-natural--633.png"
          className="w-12 h-12"
          alt="Logo"
        />
        <div className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff6eb3] via-[#aa81ff] to-[#6cc9ff] font-baloo2 text-2xl font-bold">
          BABY UNICORN
        </div>
      </div>
      <div className="text-white text-3xl font-bold">Sign Up</div>
      <div className="text-[#bebebe] text-lg">Create an account</div>
    </div>
                {/* ... LOGO, Heading, etc ... */}
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <VuesaxBulkSms1 />
                  <input
                    type="text"
                    placeholder="Full Name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleInputChange}
                    className="bg-transparent text-[#bebebe] outline-none placeholder-[#bebebe] w-full"
                  />
                </div>
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <VuesaxBulkSms1 />
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="bg-transparent text-[#bebebe] outline-none placeholder-[#bebebe] w-full"
                  />
                </div>
                {/* ...other fields (Phone, Password, Confirm Password, Referral) as per your design... */}
                {/* Password Field */}
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <VuesaxBulkKey1 />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="bg-transparent text-[#bebebe] outline-none placeholder-[#bebebe] w-full"
                  />
                  <span
                    onClick={() => setShowPassword((v) => !v)}
                    className="cursor-pointer ml-2 flex items-center"
                  >
                    {showPassword ? (
                      <FiEye size={22} />
                    ) : (
                      <FiEyeOff size={22} />
                    )}
                  </span>
                </div>
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <VuesaxBulkKey1 />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    className="bg-transparent text-[#bebebe] outline-none placeholder-[#bebebe] w-full"
                  />
                  <span
                    onClick={() => setShowConfirmPassword((v) => !v)}
                    className="cursor-pointer ml-2 flex items-center"
                  >
                    {showConfirmPassword ? (
                      <FiEye size={22} />
                    ) : (
                      <FiEyeOff size={22} />
                    )}
                  </span>
                </div>
                {/* Referral Code */}
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <VuesaxBulkSms1 />
                  <input
                    type="text"
                    placeholder="Referral Code"
                    name="referral_code"
                    value={formData.referral_code}
                    onChange={handleInputChange}
                    className="bg-transparent text-[#bebebe] outline-none placeholder-[#bebebe] w-full"
                  />
                </div>
                {/* Phone */}
                <div className="flex items-center gap-2 p-3.5 w-full bg-[#3a335066] rounded-md backdrop-blur-md h-[60px] items-center justify-between relative before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-md before:[background:linear-gradient(356deg,rgba(45,40,66,0)_2%,rgba(255,110,179,1)_16%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_83%,rgba(50,43,70,0)_97%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none">
                  <PhoneInput
                    country={"th"}
                    value={formData.phone}
                    onChange={(phone, data) => {
                      setFormData((prev) => ({
                        ...prev,
                        phone,
                        country_name: data?.name || "",
                      }));
                    }}
                    inputStyle={{
                      background: "transparent",
                      border: "none",
                      color: "#bebebe",
                      width: "100%",
                    }}
                    buttonStyle={{
                      background: "transparent",
                      border: "none",
                      paddingLeft: "10px",
                    }}
                    dropdownStyle={{
                      backgroundColor: "#1e1a2e",
                      color: "#fff",
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#ff6eb3] via-[#aa81ff] to-[#6cc9ff] text-white font-semibold px-8 py-3 rounded-full shadow-md"
                  disabled={loading}
                >
                  {loading ? "Please wait..." : "Sign Up"}
                </button>

                {/* OR Divider */}
                <div className="text-center text-[#bebebe] w-full text-sm text-opacity-60">
                  — or —
                </div>
                {/* OR Google Sign Up Button */}
                <div className="flex flex-col items-start gap-6 relative self-stretch w-full flex-[0_0_auto]">
                  <div
                    onClick={googleSignUp}
                    className="cursor-pointer flex h-[60px] items-center justify-center gap-2 px-3 py-3.5 relative self-stretch w-full 
                      rounded-[50px] border-[none] transition hover:opacity-90 active:scale-[.98]
                      before:content-[''] before:absolute before:inset-0 before:p-px before:rounded-[50px]
                      before:[background:linear-gradient(90deg,rgba(255,110,179,1)_0%,rgba(170,129,255,1)_47%,rgba(107,201,255,1)_100%)]
                      before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]
                      before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none"
                  >
                    <span className="relative w-fit font-normal text-white text-lg text-center">
                      Sign up with Google
                    </span>
                  </div>
                </div>
              </form>
            ) : (
              // ---> OTP BOX --->
              <OtpVerificationBox
                email={email}
                otp={otp}
                setOtp={setOtp}
                onVerify={handleVerifyOTP}
                minutes={minutes}
                seconds={seconds}
                loading={loading}
                resendDisabled={timer > 0}
                onResend={handleSendOTP}
              />
            )}

            <p className="text-center text-lg font-inter text-[#bebebe] mt-6">
              Have an account?{" "}
              <a href="/login" className="text-[#93b5ff] hover:underline">
                Sign in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpPage;
